import React from 'react';

const ButtonLoader = () => {
    return (
        <div className="btn__loader-container">
            <div className="btn__loader">
                <svg className="btn__loader-svg" viewBox="0 0 80 80">
                    <circle className="btn__loader-circle" id="test" cx="40" cy="40" r="32" />
                </svg>
            </div>
            <div className="btn__loader-msg">Please Wait... 😎</div>
        </div>
    );
};

export { ButtonLoader };
